import React from "react";
import { FaPlus } from "react-icons/fa";
import { Link } from "react-router-dom";

const AboutAreaOne = () => {
  return (
    <>
      {/* ================== AboutAreaOne start  ==================*/}
      <div className='about-area pd-top-120'>
        <div className='container'>
          <div className='row'>
            <div className='col-lg-6'>
              <div
                className='about-thumb-inner pe-xl-5 me-xl-5 '
                data-aos='fade-right'
                data-aos-delay='100'
                data-aos-duration='1500'
              >
                <img
                  className='animate-img-1 top_image_bounce'
                  src='assets/img/about/2.png'
                  alt='img'
                />
                <img
                  className='animate-img-2 left_image_bounce'
                  src='assets/img/about/3.png'
                  alt='img'
                />
                <img
                  className='animate-img-3 top_image_bounce'
                  src='assets/img/banner/5.svg'
                  alt='img'
                />
                <img
                  className='main-img'
                  src='assets/img/02.png'
                  alt='img'
                />
              </div>
            </div>
            <div
              className='col-lg-6 '
              data-aos='fade-left'
              data-aos-delay='100'
              data-aos-duration='1500'
            >
              <div className='section-title mt-5 mt-lg-0'>
                <h6 className='sub-title'>ABOUT</h6>
                <h2 className='title'>
                Bhavanya <span>Travel Mart</span> Private Limited
                </h2>
                <p className='content mb-4 mb-xl-5'>
                At Bhavanya Travel Mart Private Limited, we believe travel is more than just reaching a
                 destination — it's about creating unforgettable experiences. 
                </p>
                <div className='row'>
                  <div className='col-md-6'>
                    <div className='single-about-inner'>
                      <div className='thumb mb-3'>
                        <img src='assets/img/icon/2.png' alt='img' />
                      </div>
                      <div className='details'>
                        <h5>Our Mission</h5>
                        <p>
                        To provide reliable, affordable, and customized travel services
                         that exceed customer expectations,
                         while ensuring safety, comfort,
                          and convenience at every step of the journey.
                        </p>
                      </div>
                    </div>
                  </div>
                  <div className='col-md-6'>
                    <div className='single-about-inner'>
                      <div className='thumb mb-3'>
                        <img src='assets/img/icon/3.png' alt='img' />
                      </div>
                      <div className='details'>
                        <h5>Our Vision</h5>
                        <p>
                        To become one of India’s most trusted travel partners by delivering innovative
                         travel solutions, exceptional customer service, and 
                         enriching travel experiences across the globe.
                        </p>
                      </div>
                    </div>
                    

                  </div>
                </div>
                <Link
                         className='btn btn-border-base'
                         data-aos='fade-right'
                           data-aos-delay='300'
                             data-aos-duration='1500'
                           to='/AboutCompany' >
                                     Read More <FaPlus />
                                    </Link>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* ================== AboutAreaOne End  ==================*/}
    </>
  );
};

export default AboutAreaOne;
